import { SHAPE_STROKE_WIDTH_PIXELS, type ShapeStrokeWidth } from "./shape-preference";
import { normalizeColorForCompare } from "./hex-color";

/** コネクタ（接続矢印）の既定の線色。既存の未設定オブジェクトもこの色で描画する。 */
export const CONNECTOR_DEFAULT_STROKE = "#475569";

/** コネクタの線幅プリセットと実際の px 値の対応。 */
export const CONNECTOR_STROKE_WIDTH_PIXELS: Readonly<Record<ShapeStrokeWidth, number>> =
  SHAPE_STROKE_WIDTH_PIXELS;

/** strokeWidth 未設定の既存コネクタに補う既定線幅。 */
export const CONNECTOR_DEFAULT_STROKE_WIDTH = CONNECTOR_STROKE_WIDTH_PIXELS.medium;

/** コネクタの線色に使用する濃色プリセット。 */
export const CONNECTOR_STROKE_PRESET_COLORS: readonly string[] = [
  CONNECTOR_DEFAULT_STROKE,
  "#1a1a2e",
  "#d22b2b",
  "#1e63d4",
  "#0f8a4d",
  "#e08b00",
];

/** 比較用の表現へ揃える。未設定は実際の描画と同じ既定色へ寄せる。 */
export function normalizeConnectorStrokeForCompare(stroke: string | undefined): string {
  return normalizeColorForCompare(stroke ?? CONNECTOR_DEFAULT_STROKE);
}

/** px 値を線幅プリセットへ逆引きする。プリセット外は混在表示と同じ null を返す。 */
export function resolveConnectorStrokeWidthKind(px: number | undefined): ShapeStrokeWidth | null {
  const effective = px ?? CONNECTOR_DEFAULT_STROKE_WIDTH;
  for (const kind of Object.keys(CONNECTOR_STROKE_WIDTH_PIXELS) as ShapeStrokeWidth[]) {
    if (CONNECTOR_STROKE_WIDTH_PIXELS[kind] === effective) return kind;
  }
  return null;
}
